<template>
  <div>
    <h6>当前分类问题的提问说明：</h6>
    <p class="text-secondary">
      {{ `您当前的免积分提问次数为${p_selectedTag.askingChances}次。` }}
      {{ `提问次数用完后，` }}
      {{ `每提出一个问题会消耗${p_selectedTag.pointsPerQuestion}积分。` }}
    </p>
    <p class="text-secondary">
      {{ `您当前的积分为${p_selectedTag.bonusPoint}分。` }}
    </p>
    <p class="text-secondary">升级班型后可解锁免积分无限制提问资格。</p>
    <p class="text-secondary">
      {{ '升级班型请联系辅导员或品职技术客服pzacademy-tech' }}
    </p>
    <p class="text-red" v-if="p_selectedTag.c_isSelectedTagDisabled">
      {{ `您当前的积分不足${p_selectedTag.pointsPerQuestion}积分，` }}
      {{ `如需提问当前分类下的问题，请先到` }}
      <router-link :to="`/points`">积分中心</router-link>充值。
    </p>
    <hr />
  </div>
</template>
<script>
export default {
  name: 'qa-limit',

  props: {
    p_selectedTag: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style lang="scss" scoped></style>
